<template>
    <b-dropdown
        ref="timeRangeCalendar"
        variant="primary"
        right
        no-flip
        :disabled="disabled"
        menu-class="p-0"
    >

        <template #button-content>
            <span v-if="internalDates && internalDates.length === 2">
                {{ $format.date(internalDates[0]) }} – {{ $format.date(internalDates[1]) }}
            </span>
            <i class="icon">
                <feather type="chevron-down" class="align-middle" />
            </i>
        </template>

        <b-dropdown-form form-class="p-0">
            <div class="p-3" @click.stop @mousedown.stop>
                <FormPickerDate
                    v-model="internalDates"
                    range
                    confirm
                    inline
                    shortcuts
                    @confirm="onConfirm"
                    @cancel="onCancel"
                />
            </div>
        </b-dropdown-form>

    </b-dropdown>
</template>



<script>
    import { DEFAULT_TIME_RANGE, AVAILABLE_OPTIONS, dateWithoutUTC, getTimeRangeCustom } from '@/utils/timeRanges';
    import FormPickerDate from '@/components/common/FormPickerDate.vue';

    export default {
        name: 'TimeRangeCalendar',
        components: {
            FormPickerDate,
        },
        props: {
            value: {
                type: Object,
                default: () => {
                    const { startDate, endDate, compareStartDate, compareEndDate } = DEFAULT_TIME_RANGE;
                    return { startDate, endDate, compareStartDate, compareEndDate };
                },
            },
            options: {
                type: Array,
                default: () => [...AVAILABLE_OPTIONS],
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                internalDates: this.buildInitialDates(this.value),
            };
        },
        watch: {
            value: {
                handler(newVal) {
                    const newDates = this.buildInitialDates(newVal);
                    // porównujemy po getTime(), żeby nie ustawiać zbędnie tej samej wartości
                    if (!this.internalDates || this.internalDates.length !== 2 || this.internalDates[0].getTime() !== newDates[0].getTime() || this.internalDates[1].getTime() !== newDates[1].getTime()) {
                        this.internalDates = newDates;
                    }
                },
                deep: true,
                immediate: true,
            },
        },
        methods: {
            buildInitialDates(valueObj) {
                let sd = valueObj?.startDate;
                let ed = valueObj?.endDate;
                if (!sd || !ed) {
                    sd = DEFAULT_TIME_RANGE.startDate;
                    ed = DEFAULT_TIME_RANGE.endDate;
                }
                return [dateWithoutUTC(sd), dateWithoutUTC(ed)];
            },
            onConfirm(pickerDates) {
                this.internalDates = pickerDates;
                this.emitData(this.internalDates, true);
                this.$refs.timeRangeCalendar.hide(true);
            },
            onCancel() {
                this.internalDates = this.buildInitialDates(this.value);
                this.$refs.timeRangeCalendar.hide(true);
            },
            emitData(datesArray, change) {
                const timeRange = this.getTimeRange(datesArray);
                this.$emit('input', timeRange);
                this.$emit('startDate', timeRange.startDate);
                this.$emit('endDate', timeRange.endDate);
                this.$emit('timeRange', timeRange);
                if (change) {
                    this.$emit('change', timeRange);
                }
            },
            getTimeRange(dates) {
                const { startDate, endDate, compareStartDate, compareEndDate } = getTimeRangeCustom(dates);
                return { startDate, endDate, compareStartDate, compareEndDate };
            },
        },
        created() {
            if (!this.value?.startDate || !this.value?.endDate) {
                this.emitData(this.internalDates, false);
            }
        },
    };
</script>
